/* 新規作成（SE）モーダル */
import React, { memo } from 'react';
import { Col } from 'react-bootstrap';
import ModalTemplate from '../molecules/ModalTemplate';
import Messages from '../molecules/Messages';
var NewRegistrationSE = function (_a) {
    var t = _a.t, show = _a.show, value = _a.value, valid_msg = _a.valid_msg, handleClickCallBackYes = _a.handleClickCallBackYes, handleClickCallBackNo = _a.handleClickCallBackNo, handleChangeInput = _a.handleChangeInput, handleBlur = _a.handleBlur;
    return (React.createElement(ModalTemplate, { show: show, title: t('新規作成'), body: React.createElement("div", { className: "new-registration-modal" },
            React.createElement(Col, { md: 12 },
                React.createElement("p", { className: "new-registration-p" }, "\u4FDD\u8A3CNo.\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                React.createElement("input", { id: "se_create_reception", type: "text", className: 'search-form-input maximum', onChange: handleChangeInput, value: value, maxLength: 10, onBlur: handleBlur }),
                React.createElement(Messages, { valid_msg: valid_msg }))), ClickCallBackNo: function () {
            handleClickCallBackNo();
        }, ClickCallBackYes: function () {
            handleClickCallBackYes();
        }, t: t }));
};
export default memo(NewRegistrationSE);
